import { observable } from 'mobx';
import { ViewController } from '@estee/elc-service';
import { HoverZoom } from '~domain/entities/HoverZoom';

export class ProductHoverZoomButtonViewController extends ViewController {
    @observable hoverZoom: HoverZoom;

    constructor(hoverZoom: HoverZoom) {
        super();
        this.hoverZoom = hoverZoom;
    }

    public openZoomByIndex = (index: number = 0) => {
        const { setCurrentZoomSlideIndex, openZoom } = this.hoverZoom;
        setCurrentZoomSlideIndex(index);
        openZoom();
    };
}
